import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Play, CheckCircle } from 'lucide-react';
import { droneImage, companyInfo } from '../../data/mock';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-0 right-0 w-96 h-96 bg-blue-200 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-100 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text Content */}
          <div>
            <div className="inline-flex items-center bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <span className="w-2 h-2 bg-blue-600 rounded-full mr-2 animate-pulse" />
              Partenaire Officiel Keelcrab Pro
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight mb-4">
              Nettoyage de coques
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-800">
                par drone sous-marin
              </span>
            </h1>

            <p className="text-xl md:text-2xl font-medium text-blue-600 mb-6 italic">
              {companyInfo.slogan}
            </p>
            
            <p className="text-lg text-slate-600 mb-8 leading-relaxed max-w-lg">
              Service professionnel de nettoyage de coque sans devoir sortir votre bateau de l'eau, avec inspection vidéo HD.
              <br /><br />
              Intervention sur le Lac Léman, Lac de Neuchâtel et Lac de Morat.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-8 py-4 rounded-xl font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 gap-2"
              >
                Demander un devis gratuit
                <ArrowRight className="w-5 h-5" />
              </Link>
              <Link
                to="/keelcrab"
                className="inline-flex items-center justify-center bg-white hover:bg-slate-50 text-slate-700 px-8 py-4 rounded-xl font-semibold transition-all duration-300 shadow-md hover:shadow-lg gap-2 border border-slate-200"
              >
                <Play className="w-5 h-5 text-blue-600" />
                Voir le robot en action
              </Link>
            </div>

            {/* Features */}
            <div className="flex flex-wrap gap-4">
              {['Sans mise au sec', 'Écologique', 'Vidéo HD incluse'].map((feature, idx) => (
                <div key={idx} className="flex items-center gap-2 text-slate-600">
                  <CheckCircle className="w-5 h-5 text-blue-600" />
                  <span className="text-sm font-medium">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative bg-white rounded-3xl shadow-2xl p-3 transform hover:scale-[1.02] transition-transform duration-500">
              <img
                src={droneImage}
                alt="Drone Keelcrab Pro - Nettoyage de coque sous-marin"
                className="w-full h-auto rounded-2xl"
              />
              {/* Badge */}
              <div className="absolute -bottom-4 -right-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-3 rounded-xl shadow-lg">
                <span className="text-sm font-semibold">Technologie Keelcrab Pro</span>
              </div>
            </div>
            
            {/* Decorative elements */}
            <div className="absolute -top-8 -left-8 w-24 h-24 bg-blue-500/10 rounded-full blur-2xl" />
            <div className="absolute -bottom-8 -right-8 w-32 h-32 bg-blue-600/10 rounded-full blur-2xl" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
